import {
    Grid
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React, { Component } from "react";
import { connect } from "react-redux";
import { saveReport } from '../../Slice/matrixReport.slice';

import {
    showLoador,
    showNotification,
} from "../../Pages/Landing/Landing.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import { withRouter } from "../../components/withRouter";
import * as msgConstant from "../../config/messageconstant";
import AddTableColoumnsPopUp from "./AddTableColoumnsPopUp";
import TableColumnsDetails from "./TableColumnsDetails";

class ReportForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumnsList: [],
            reportName: "",
            type: "",
            isGraph: "1",
            isSubReport: "0",
            formValidErrors: {},
            fieldData: {},
            fieldDataEdit: {},
            formErrors: {},
            editData: {},
            openDialog: false,
            rowData: {}
        };
    }

    componentDidMount() {
        const { value } = this.props
        let tableColumnsList = value == 3 && JSON.parse(this.props.report.reportData.tableColumns1) ? JSON.parse(this.props.report.reportData.tableColumns1) : value == 5 && JSON.parse(this.props.report.reportData.tableColumns2) ? JSON.parse(this.props.report.reportData.tableColumns2) : value == 7 && JSON.parse(this.props.report.reportData.tableColumns3) ? JSON.parse(this.props.report.reportData.tableColumns3) : []
        this.setState({
            tableColumnsList: tableColumnsList,
        });
    }
    onFormSave = () => {

        const tableData = this.state.tableColumnsList.sort(function (a, b) {
            return +a.sortNo - b.sortNo;
        });
        this.onSave({ ...this.props.report.reportData, tableColumns: JSON.stringify(tableData) })
        console.log(tableData)
    };
    onSave = (dataToSave) => {
        if (navigator.onLine) {
            const {
                saveReport,
                showLoador,
                showNotification,
            } = this.props;
            showLoador({ loador: true });
            saveReport({ dataToSave }).then(({ success }) => {
                showLoador({ loador: false });
                if (success) {
                    this.props.changeTab(this.props.value == 3 ? 4 : this.props.value == 5 ? 6 : 8)
                    showNotification({
                        msg: dataToSave.id ? msgConstant.deletemsg : msgConstant.savemsg,
                    });

                } else {
                    showNotification({
                        msg: msgConstant.saveFailedMsg,
                        severity: "error",
                    });
                }
            });
        } else {
            showNotification({
                msg: msgConstant.noInternetMsg,
                severity: "error",
            });
        }
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.report != this.props.report) {
            if (nextProps.report.reportData != this.props.report.reportData) {
                const { value } = this.props
                let tableColumnsList = value == 3 && JSON.parse(nextProps.report.reportData.tableColumns1) ? JSON.parse(nextProps.report.reportData.tableColumns1) : value == 5 && JSON.parse(nextProps.report.reportData.tableColumns2) ? JSON.parse(nextProps.report.reportData.tableColumns2) : value == 7 && JSON.parse(nextProps.report.reportData.tableColumns3) ? JSON.parse(nextProps.report.reportData.tableColumns3) : []
                this.setState({
                    tableColumnsList: tableColumnsList,
                });
            }
        }
    }
    onRadioChange = (event) => {
        this.setState({ isSubReport: event.target.value });
    };

    onCancel = () => {
        this.props.navigate(-1);
    };

    rowEdit = (rowData) => {
        this.setState({
            rowData: rowData
        })
        this.toggleFilter()
    }
    toggleFilter = () => {
        if (this.state.openDialog) {
            this.setState({
                rowData: {},
            })
        }
        this.setState({
            openDialog: !this.state.openDialog,
        })
    }
    render() {
        const { tableColumnsList, rowData, openDialog } = this.state;
        return (
            <>

                <Grid container sx={{ marginTop: 2 }} spacing={1}>

                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                    >
                        <ButtonCompo
                            sx={{ color: 'white', backgroundColor: '#0f3f6f' }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Add"}
                            onClick={this.toggleFilter}
                            fullWidth={false}
                        />
                    </Grid>

                </Grid>
                <br />
                <TableColumnsDetails rowData={rowData} value={this.props.value} rowEdit={this.rowEdit} rowList={tableColumnsList} />
                <br />
                <Grid
                    item
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    rowSpacing={2}
                    columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                    container
                    justifyContent="right"
                >
                    <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name="Save and Next"
                        // fullWidth={true}
                        onClick={this.onFormSave}
                    />

                </Grid>
                {
                    openDialog &&
                    <AddTableColoumnsPopUp value={this.props.value} openDialog={openDialog} tableColumnsList={tableColumnsList} rowDataEdit={rowData} setOpenDialouge={() => {
                        this.setState({
                            openDialog: false,
                            rowData: {},
                        })
                    }}
                    />}
            </>
        );
    }
}
const mapStateToProps = (state) => ({ report: state.matrixReport });
const mapDispatchToProps = { showLoador, showNotification, saveReport };
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ReportForm);
